import { Pipe, PipeTransform } from '@angular/core';

import { formatEther } from 'viem';

import { Calcs } from '@/models/pipes';
import { Punk } from '@/models/graph';

@Pipe({
  standalone: true,
  name: 'calc'
})

export class CalcPipe implements PipeTransform {
  private toEthSafe(weiValue: unknown): number | null {
    if (weiValue === null || weiValue === undefined) return null;

    if (typeof weiValue === 'number') {
      if (!Number.isFinite(weiValue) || !Number.isInteger(weiValue)) return null;
      return Number(formatEther(BigInt(weiValue)));
    }

    if (typeof weiValue === 'string') {
      const normalized = weiValue.trim();
      if (!normalized) return null;
      if (!/^-?\d+$/.test(normalized)) return null;
      return Number(formatEther(BigInt(normalized)));
    }

    if (typeof weiValue === 'bigint') {
      return Number(formatEther(weiValue));
    }

    return null;
  }

  transform(value: Punk[], type: Calcs): number {

    if (!value?.length) return 0;
    if (!type) return 0;

    if (type === 'lowestListingPrice') {
      const listingValues = value
        .map((item) => this.toEthSafe(item?.listing?.value))
        .filter((ethValue): ethValue is number => ethValue !== null);

      if (!listingValues.length) return 0;
      return Math.min(...listingValues);
    }

    if (type === 'averageBidPrice') {
      const bidValues = value
        .map((obj) => this.toEthSafe(obj?.bid?.value))
        .filter((ethValue): ethValue is number => ethValue !== null);

      if (!bidValues.length) return 0;
      return bidValues.reduce((sum, ethValue) => sum + ethValue, 0) / bidValues.length;
    }

    if (type === 'averageYearBidPrice') {
      const bidValues = value
        .filter((res, i) => i < 366)
        .map((obj) => this.toEthSafe(obj?.bid?.value))
        .filter((ethValue): ethValue is number => ethValue !== null);

      if (!bidValues.length) return 0;
      return bidValues.reduce((sum, ethValue) => sum + ethValue, 0) / bidValues.length;
    }

    if (type === 'totalBidsValue') {
      const bidValues = value
        .map((obj) => this.toEthSafe(obj?.bid?.value))
        .filter((ethValue): ethValue is number => ethValue !== null);

      if (!bidValues.length) return 0;
      return bidValues.reduce((sum, ethValue) => sum + ethValue, 0);
    }

    return 0;
  }
}
